import { request } from '@/api/httpClient'

export async function stylingGetCompanyStyling(companyId) {
  return request({
    method: `styling/GetCompanyStyling?companyId=${companyId}`
  })
}

export async function stylingUpdateCompanyStyling(payload) {
  return request({
    method: 'styling/UpdateCompanyStyling',
    payload
  })
}
